import React, { useEffect, useState } from 'react';

import CustomTooltip, { POSITIONS } from '@components/CustomTooltip';

import { PLANNING_STATUS } from '@features/order/utils/projectUtil';

import { getShortName, replaceSymbols, STATIC_SET_CONSTANTS } from '@utils/Util';

const AvailableProductToDuplicate = ({ tnaProductList = [], onSelectStyleForDuplication }) => {
	return (
		tnaProductList?.length > 0 &&
		tnaProductList.map((product, idx) => {
			return (
				<li
					key={`product-${idx}-${product?.rfqId}`}
					onClick={() => onSelectStyleForDuplication(product?.rfqId, product?.id)}
				>
					<div className="d-flex align-items-center cursor-pointer">
						<img src={product?.image} alt="design" />
						<CustomTooltip
							text={product?.referenceNumber}
							position={POSITIONS.LEFT}
							arrowCenter={true}
						>
							<p className="regular-12 gray_dark_01 ml-2">
								{getShortName(product?.referenceNumber, 16)}
							</p>
						</CustomTooltip>
					</div>
				</li>
			);
		})
	);
};

const CreateDuplicateTNA = ({
	activeSetMemberId,
	productsOfSet,
	selectedTemplateDays,
	loading,
	tnaTemplateDays,
	tnaProductList = [],
	onSelectStyleForDuplication,
	onTemplateDayChange,
	isExcelFileSubmitted
}) => {
	const [allProducts, setAllProducts] = useState([]);

	const organizeAllProductIncludingSet = (tnaProducts) => {
		const products = [];
		const copyProducts = [...tnaProducts];
		const addedProductIds = new Set(); // To track added product ids

		copyProducts.forEach((design) => {
			if (design.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT && design.setMemberList) {
				design.setMemberList.forEach((member) => {
					if (
						member.planningStatus !== PLANNING_STATUS.PENDING &&
						!addedProductIds.has(member.id)
					) {
						products.push({
							...member
						});
						addedProductIds.add(member.id);
					}
				});
			} else if (design.planningStatus !== PLANNING_STATUS.PENDING && !addedProductIds.has(design.id)) {
				products.push({
					...design
				});
				addedProductIds.add(design.id);
			}
		});
		setAllProducts(products);
	};

	useEffect(() => {
		organizeAllProductIncludingSet(tnaProductList);
	}, [tnaProductList]);

	return (
		<React.Fragment>
			<div className="single-filter">
				{/* Select Template Days */}
				<div className="date-filter">
					<div className="dropdown">
						<button
							className="btn btn-default dropdown-toggle"
							type="button"
							data-toggle="dropdown"
							disabled={
								isExcelFileSubmitted() ||
								(activeSetMemberId && productsOfSet[0]?.id !== activeSetMemberId)
							}
						>
							<span>
								{!selectedTemplateDays
									? 'Select'
									: replaceSymbols(selectedTemplateDays?.templateName, '_', ' ')}
							</span>
						</button>
						<ul className="dropdown-menu">
							{!loading &&
								tnaTemplateDays.map((day) => (
									<li
										key={day?.templateDurationDays}
										onClick={() => onTemplateDayChange(day)}
									>
										<span>{day?.templateDurationDays} days</span>
									</li>
								))}
						</ul>
					</div>
				</div>
			</div>
			{/* Select Duplicate Template */}
			<div className="single-filter">
				<div className="duplicate-filter">
					<div className="dropdown">
						<button
							className="btn btn-default dropdown-toggle"
							type="button"
							data-toggle="dropdown"
							disabled={isExcelFileSubmitted()}
						>
							<span>Duplicate</span>
						</button>
						<ul className="dropdown-menu">
							{!loading && allProducts?.length > 0 && (
								<AvailableProductToDuplicate
									tnaProductList={allProducts}
									onSelectStyleForDuplication={onSelectStyleForDuplication}
								/>
							)}
						</ul>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default CreateDuplicateTNA;
